import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import { BsModalRef, BsModalService } from "ngx-bootstrap";
import * as fromRootStore from "../../../reducers";
import { Combo2Service, ReportService } from "../../../services/index";
import * as commonActions from "../../../store/actions/common.actions";
import { SalesOrderDetailsReport } from "./SalesOrderdetails";
declare var google;

@Component({
  selector: "design-wise-so-report",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./SalesOrder.html",
})
export class SalesOrderReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  filter = {
    fin_id: 3,
    season: 0,
    season_id: 3,
    design_no: "",
    opmin: "",
    opmax: "",
    oqmin: "",
    oqmax: "",
    search: "",
  };
  page = {
    limit: 99999,
    count: 0,
    offset: 0,
    orderBy: "agent_name",
    orderDir: "asc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("nameTemplate") nameTemplate: TemplateRef<any>;
  @ViewChild("addrTemplate") addrTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  user: any;
  agentVisible: boolean = false;
  agentList$ = [];
  companyInfo: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private combo2Service: Combo2Service,
    private reportService: ReportService,
    private modalService: BsModalService,
    public toasterService: ToasterService
  ) {}

  printConfig: any = {
    title: "Design Wise Sales Order report",
    columns: [],
    rows: [],
  };

  ngOnInit(): void {
    this.loadAgentList();
    this.loadfinyearList();
    this.loadPartyList();
    this.loadSeasonList();
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
    this.checkuser();
    if (this.user.username == "admin") {
      this.filterData = {
        fin_id: 3,
        season_id: "3",
        party_id: "",
        agent_id: "",
      };
    } else {
      this.filterData = {
        fin_id: 3,
        season_id: "3",
        party_id: "",
        agent_id: this.user.params.agent_id,
      };
    }
    this.pageCallback({ offset: 0 });
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  checkuser() {
    let that = this;

    if (this.user.params && !this.user.params.agent_id) {
      that.agentVisible = true;
    }
  }

  getColumns() {
    const colName = this.reportName == "design_no" ? "design_no" : "dispName";
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        summaryFunc: (cells) => "Sample",
      },
      {
        name: "Order No",
        prop: "so_no",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Order Date",
        prop: "so_date",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Party Name",
        prop: "party_name",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        name: "Agent Name",
        prop: "agent_name",
        minWidth: 200,
        maxWidth: 200,
        width: 200,
      },
      {
        name: "F Qty",
        cellClass: "txtRight",
        prop: "fqty",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H Qty",
        cellClass: "txtRight",
        prop: "hqty",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "Tot Qty",
        cellClass: "txtRight",
        prop: "totqty",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "Order Type",
        cellClass: "txtRight",
        prop: "order_type",
        minWidth: 150,
        maxWidth: 150,
        width: 150,
      },
    ];
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#jdkf").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    this.getSalesOrder();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getSalesOrder();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.getSalesOrder();
  }

  getSalesOrder(): void {
    let filterData = Object.assign({}, this.filterData);
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(filterData),
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    this.isLoadMask = this.reportService
      .getSOReport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.dataList = res.data;
        that.printConfig = {
          title: "Design Wise Sales Order report",
          columns: that.columns,
          rows: that.dataList,
        };
        that.refreshData();
        //  that.columns = res.columns;
      });
  }

  clearFilter(): void {
    this.filterData = {
      fin_id: "",
    };
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.getSalesOrder();
  }

  loadSeasonList() {
    let that = this;
    this.combo2Service.seasonCombo().then(function (res) {
      //  this.LoadAgentList();
      that.seasonList = res.data;
      that.seasonCtrl.setValue(res.data[0].season_id);
      //this.getSalesOrder();
    });
  }
  loadfinyearList() {
    let that = this;
    this.combo2Service.finyearCombo().then(function (res) {
      //  this.LoadAgentList();
      that.finyearList = res.data;
      that.finyearCtrl.setValue(res.data[0].fin_id);
      that.OnSelectFinyear(res.data[0].fin_id);
    });
  }

  displayFinyear(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "FinYear") {
      list = this.finyearList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { fin_id: id });
      return fitem["finyear"];
    }
    return "";
  }

  displaySeason(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Season") {
      list = this.seasonList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }

  displayFn1(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Agent") {
      list = this.agentList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { agent_id: id });
      return fitem["agent_name"];
    }
    return "";
  }

  displayParty(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    if (comboType == "Party") {
      list = this.partyList;
    }

    if (id && list.length > 0) {
      let fitem = _.find(list, { party_id: id });
      return fitem["party_name"];
    }
    return "";
  }

  OnSelectFinyear(fin_id) {
    let seasonfinList = _.filter(this.seasonList, { fin_id: fin_id });
    this.seasonfinList = seasonfinList;
  }

  loadAgentList() {
    let that = this;
    this.combo2Service.agentCombo().then((res: any) => {
      that.agentList = res.data;
    });
  }

  OnSelectagent(agent_id) {
    let partyAgentList = _.filter(this.partyList, { agent_id: agent_id });
    this.partyAgentList = partyAgentList;
  }

  loadPartyList() {
    let that = this;
    this.combo2Service.partyCombo().then((res: any) => {
      that.partyList = res.data;
    });
  }

  bsModalRef: BsModalRef;
  onSelectSalesOrder($event) {
    let that = this;
    let so_id = $event.selected[0].so_id;

    this.bsModalRef = this.modalService.show(SalesOrderDetailsReport, {
      keyboard: false,
      ignoreBackdropClick: true,
      class: "compWidth-90",
    });
    //
    this.bsModalRef.content.title = "Sales Order Details";
    this.bsModalRef.content.mapdata = so_id;
    this.bsModalRef.content.brandUpdateEvent.subscribe(($e) => {
      // that.getItemMapList();
      this.store.dispatch(new commonActions.LoadAllItem());
    });
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      rowtype: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/OrderwiseReport/SalesOrder.ts